module.exports = __webpack_public_path__ + "static/media/doulanshan2.36c5b73b.jpg";